import { IWalletTicket, IWalletTicketFilter } from 'meta/pages/wallet'
import { useAppSelector } from 'store'
import { WalletSelectors } from 'store/pages/wallet'

export const useWalletTickets = (filter: IWalletTicketFilter): Array<IWalletTicket> | undefined =>
  useAppSelector(WalletSelectors.getWalletTickets({ filter }))
